import { createAction, props } from "@ngrx/store";
import { InitialDataModel } from "../nmj-initial-data/state";
import { KeyValueModel } from "@ifaa-components/ui-components";
import { PersonalDetailsModel } from "src/app/model/member-details.model";

export const ResetDataSavedAction = createAction('[Details Form] reset data saved property');

export const SetDataFromInitialDataStepAction = createAction('[Details Form] set data from initial data step', props<{ data: InitialDataModel }>())

export const SaveDetailsRequestAction = createAction('[Details Form] save page details',
    props<{ step: number, field: string, data: PersonalDetailsModel }>());

export const SaveDetailsResponseAction = createAction('[Details Form] update next page response');

export const UpdateDetailsFieldRequestAction = createAction('[Details Form] update request',
  props<{ step: number, field: string, data: PersonalDetailsModel }>());
export const UpdateDetailsFieldResponseAction = createAction('[Details Form] update response');

export const GetGenderOptionsRequestAction = createAction('[Details Form] get gender options')
export const GetGenderOptionsResponseAction = createAction('[Details Form] set gender options', props<{genders:KeyValueModel[]}>())

export const SetDetailsErrorAction = createAction('[Details Form] set details error');

export const SetDetailsLoadingAction = createAction('[Details Form] set api loading')